import { connect } from 'react-redux';

import ContentHubPage from 'components/ContentHubPage';
import ContentHubPageModel from 'models/ContentHubPage';

const mapStateToProps = (state, ownProps) => {
  const { data } = ownProps;
  const contentHubPage = new ContentHubPageModel({ ...data });

  return {
    contentHubPage,
  };
};

export default connect(mapStateToProps)(ContentHubPage);
